import type { Component } from 'vue';

export const DialogVariants = {
    Primary: 'primary',
    Danger: 'danger',
    Info: 'info',
    Warning: 'warning',
} as const;

export type DialogVariant = typeof DialogVariants[keyof typeof DialogVariants];

export interface DialogConfig {
    title: string;
    message: string;
    variant?: DialogVariant;
    actionText?: string;
    actionIcon?: Component;
    cancelText?: string;
    cancelIcon?: Component;
    hideNoButton?: boolean;
    data?: unknown;
}
